// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2OUef","topBottomGutter":"Layout_topBottomGutter__HVye7"};